import { FileInput, FileInputProps } from '@infotech-soe/erp-ui-kit';
import React from 'react';

import { FileInputFormControlViewModel } from '../../../services/form/view-model/FormControlViewModel';

import { TFormControlConnectorProps } from './FormControlContainer';
import FormLabeledInputControl from './FormLabeledInputControl';

interface Props
  extends
    Omit<TFormControlConnectorProps, 'onChange' | 'onChanged' | 'onSubmit'>,
    Pick<FileInputProps, 'onChange' | 'onChanged' | 'onSubmit' | 'invalid'> {
  control: FileInputFormControlViewModel;
}

const FormFileInputControl = ({
  areHintsShown,
  control,
  onChange,
  onChanged,
  onSubmit,
}: Props): React.JSX.Element => (
  <FormLabeledInputControl areHintsShown={areHintsShown} control={control}>
    <FileInput
      accept={control.accept}
      disabled={control.disabled}
      invalid={control.invalid}
      required={control.required}
      onChange={onChange}
      onChanged={onChanged}
      onSubmit={onSubmit}
    />
  </FormLabeledInputControl>
);

export default FormFileInputControl;
